<template>
    <div>
        <h1>Account Info</h1>
        <div class="stripe-container">
          <h3>Name:</h3>
          <p>{{user.displayName}}</p>
          <h3>Email:</h3>
          <p>{{user.email}}</p>
        </div>
        <a-button v-if="!user.lifetimeStatus" :loading="loading" class="btn btn-outline-primary" @click="customerPortal">Manage Subscription</a-button>
        <p v-else>You have lifetime access without billing :)</p>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { firebaseFunctions } from '@/services/firebase'

export default {
  computed: {
    ...mapState(['user']),
    loading() {
      return this.$store.state.user.loading
    },
  },
  methods: {
    formatString(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    async customerPortal() {
      this.$store.commit('user/SET_STATE', {
        loading: true,
      })
      const functionRef = firebaseFunctions.httpsCallable('ext-firestore-stripe-subscriptions-createPortalLink')
      const { data } = await functionRef({
        returnUrl: window.location.origin,
      })
      window.location.assign(data.url)
      this.$store.commit('user/SET_STATE', {
        loading: false,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/components/mixins.scss';
</style>
